import Indicator from '../Indicator';

/** Time Series Forecast indicator */
export default class TSFIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} componentSeries - Indicator component series
	 */
	_getDefaultParams() {
		return {
			id: 'tsf',
			name: 'Time Series Forecast',
			description: 'The Time Series Forecast function predicts a future value of a field using the value of a given period linear regression line.',
			inputs: [{ name: 'period', value: 20 }],
			componentSeries: [{ id: 'tsf' }]
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
